// extracted by mini-css-extract-plugin
module.exports = {"navWrapper":"Navigation_navWrapper__gUA5h","navList":"Navigation_navList__jnmze","headerText":"Navigation_headerText__fZaR0","linkTitle":"Navigation_linkTitle___kny2"};